import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs/observable/merge';
import { filter, map, mergeMap } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger, I18nService } from '@app/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { UtilService } from './utility/util.service';
import { UserService } from "@app/user.service";
import { AuthService } from "@app/auth.service";
import { SocketioService } from './socketio.service';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  message: string;
  messages: string[] = [];
  PortalUser: any;
  
  socialNoti: string = ""
  chatbotNoti: string = ""
  _subscription: any

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService,
    private i18nService: I18nService,
    private util: UtilService,
    private user: UserService,
    private Auth: AuthService,
    private socketService: SocketioService,
    private idle: Idle,
    private keepalive: Keepalive) {
      //subscribe for socket receive data
      //this._subscription = this.socketService.caller.subscribe((data: any) => {
        //if(data && data["user"] == sessionStorage.getItem("user")){
        //  this.chatbotNoti = data["noti"]["chatbotNoti"]
         //this.socialNoti = data["noti"]["socialNoti"]
       // }
        //else if(data && data["user"]){
         // alert('bbb')
       // }
     // });



    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(environment.timeoutIdleMinute * 60);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(environment.timeoutIdleMinute * 60);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      var dataobj = {};
      this.idleState = 'Timed out!';
      console.log(this.idleState);
      this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
      if(this.PortalUser != null || this.PortalUser.contactid != null || this.PortalUser.contactid != "")
      { 
        this.timedOut = true; 
        
        this.util.WarningDialog("ท่านถูก logout จากระบบ เนื่องจากไม่มีการใช้งาน ภายในเวลา 60 นาที")
        this.logout()
      }
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You \'ve gone idle!'
      console.log(this.idleState);
      //this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown: any) => {
      //this.idleState = 'You will time out in ' + countdown + ' seconds!'
      //console.log(this.idleState);
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }

  ngOnInit() {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    log.debug('init');

    // Setup translations
    this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);

    //connect to socket
    //this.socketService.setupSocketConnection();

  }

  
  ngOnDestroy(){
    //prevent memory leak when component destroyed
    this._subscription.unsubscribe();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  async logout() {
    var dataobj = {};
    dataobj["member_no"] = this.util.GetUserID();
    var data = this.user.logout();

    if (data.status) {
      //  await this.apiService.postnotauthen('account', 'DeleteUserSession', dataobj);
      this.Auth.setLoggedIn(false);
      window.location.reload();
    } else {
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts